import { Pipe, PipeTransform } from '@angular/core';
import { ContentAssetRule, DataMartField, isDatamartField } from '@r1-compass-library/models';

@Pipe({
    // eslint-disable-next-line @angular-eslint/pipe-prefix
    name: 'r1ContentLibraryRuleSummary',
})
export class ContentLibraryRuleSummaryPipe implements PipeTransform {
    transform(rule: ContentAssetRule, dataMartFields: DataMartField[]): string {
        const field = rule.field;

        let fieldName: undefined | string;

        if (field) {
            if (isDatamartField(field)) {
                fieldName =
                    dataMartFields.find(dataMartField => dataMartField.name === field?.name)?.displayName ?? field.name;
            } else {
                fieldName = field.name ?? '(field not defined)';
            }
        }

        let summary = '';
        summary += fieldName + ' ';
        let clause = '';

        if (!rule.comparator) {
            clause += '(comparator is not defined)';
        } else {
            switch (rule.comparator) {
                case 'blank':
                    clause += `is ${rule.not ? 'not' : ''} blank`;
                    break;
                case 'isNull':
                    clause += `is ${rule.not ? 'not' : ''} empty`;
                    break;
                case 'equals':
                    clause += `is ${rule.not ? 'not' : ''} equal to`;
                    break;
                case 'in':
                    clause += `is ${rule.not ? 'not' : ''} in list`;
                    break;
                case 'startsWith':
                    clause += rule.not ? 'does not start with' : 'starts with';
                    break;
                case 'endsWith':
                    clause += rule.not ? 'does not end with' : 'ends with';
                    break;
                case 'contains':
                    clause += rule.not ? 'does not contain' : 'contains';
                    break;
                case 'lessThan':
                    if (field) {
                        if (isDatamartField(field)) {
                            clause += field?.dataType === 'date' ? 'is before' : 'is less than';
                        } else {
                            clause += rule.field?.dataType === 'date' ? 'is before' : 'is less than';
                        }
                    }
                    break;
                case 'lessThanOrEqualTo':
                    if (field) {
                        if (isDatamartField(field)) {
                            clause += field?.dataType === 'date' ? 'is at the latest' : 'is less than or equal to';
                        } else {
                            clause += rule.field?.dataType === 'date' ? 'is at the latest' : 'is less than or equal to';
                        }
                    }
                    break;
                case 'greaterThan':
                    if (field) {
                        if (isDatamartField(field)) {
                            clause += field?.dataType === 'date' ? 'is after' : 'is greater than';
                        } else {
                            clause += rule.field?.dataType === 'date' ? 'is after' : 'is greater than';
                        }
                    }
                    break;
                case 'greaterThanOrEqualTo':
                    if (field) {
                        if (isDatamartField(field)) {
                            clause += field?.dataType === 'date' ? 'is no earlier than' : 'is greater than or equal to';
                        } else {
                            clause +=
                                rule.field?.dataType === 'date' ? 'is no earlier than' : 'is greater than or equal to';
                        }
                    }
                    break;
            }
        }

        summary += clause + ' ';

        let value = '';

        if (field && rule.value) {
            if (isDatamartField(field)) {
                if (field?.dataType === 'date') {
                    value = new Date(rule.value).toLocaleDateString();
                } else {
                    value = rule.value ?? '';
                }
            } else {
                if (rule.field?.dataType === 'date') {
                    value = new Date(rule.value).toLocaleDateString();
                } else {
                    value = rule.value ?? '';
                }
            }

            // Handling in-list values for multipick
            if (rule.comparator === 'in') {
                try {
                    const parsedVal = JSON.parse(rule.value);
                    if (Array.isArray(parsedVal)) {
                        value = (parsedVal as string[]).join(',');
                    }
                } catch (error) {
                    // swallow. we can reach this if the value cannot be parsed into JSON.
                }
            }
        }

        summary += value;
        return summary;
    }
}
